import React, { useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'antd';
import {
  AiOutlineGlobal,
  AiOutlineDelete,
  AiOutlineEdit,
} from 'react-icons/ai';
import ControlBtn from '../ControlBtn/ControlBtn';
import styles from './Link.module.scss';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';

const updatePos = (target) => {
  const right = target.getBoundingClientRect();
  const clientWidth = document.documentElement.clientWidth;

  const elHidesRight = right > clientWidth;

  return elHidesRight ? { right: 0 } : undefined;
};

const PopoverContent = ({
  url,
  onEditBtnClick,
  onDeleteBtnClick,
  onClose,
  parentRef,
}) => {
  const containerRef = useRef();

  const [pos, setPos] = useState({ right: 0 });

  const handleIntersect = async (entries, observerElement) => {
    const entry = entries[0];

    const { isIntersecting, target } = entry;

    if (!isIntersecting) {
      const newPos = updatePos(target);
      setPos(newPos);
    } else {
      observerElement.unobserve(containerRef.current);
    }
  };

  useIntersectionObserver({
    target: containerRef,
    onIntersect: handleIntersect,
    threshold: 1,
  });

  useEffect(() => {
    const outsideClickHandler = (event) => {
      if (parentRef.current && !parentRef.current.contains(event.target)) {
        onClose();
      }
    };

    const escKeyDownHandler = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', outsideClickHandler);
    document.addEventListener('keydown', escKeyDownHandler);

    return () => {
      document.removeEventListener('mousedown', outsideClickHandler);
      document.removeEventListener('keydown', escKeyDownHandler);
    };
  }, []);

  return (
    <div
      className={styles.popoverContent}
      contentEditable={false}
      readOnly
      style={pos}
      ref={containerRef}
    >
      <AiOutlineGlobal className={styles.popoverGlobalIcon} />
      <Button
        href={url}
        target="_blank"
        type="link"
        rel="noreferrer"
        className={styles.popoverLink}
      >
        {url}
      </Button>
      <Tooltip title={url[0] === 't'? 'Изменить номер телефона' : "Изменить ссылку"}>
        <ControlBtn
          shape="circle"
          content={<AiOutlineEdit />}
          className={styles.popoverControlBtn}
          onClick={onEditBtnClick}
        />
      </Tooltip>
      <Tooltip title={url[0] === 't' ? 'Удалить номер телефона' : "Удалить ссылку"}>
        <ControlBtn
          shape="circle"
          content={<AiOutlineDelete />}
          className={styles.popoverControlBtn}
          onClick={onDeleteBtnClick}
        />
      </Tooltip>
    </div>
  );
};

export default PopoverContent;
